import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { CmsApiResponse, CmsApiService } from '../_services';

@Injectable()
export class HeaderFooterResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getPublicResources();
  }
}

@Injectable()
export class HomeResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getPublicHomeResources();
  }
}

@Injectable()
export class ProductPlansResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getProductPlansResources();
  }
}

@Injectable()
export class LoginResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getLoginResources();
  }
}

@Injectable()
export class ActivateResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getActivateResources();
  }
}

@Injectable()
export class ForgotPasswordResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getForgotPasswordResources();
  }
}

@Injectable()
export class PrivacyPolicyResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getPrivacyPolicyResources();
  }
}

@Injectable()
export class ConditionsPageResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getTermsAndConditions();
  }
}

@Injectable()
export class FaqResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getPublicFaqResources();
  }
}

@Injectable()
export class ContactUsResolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getContactUsResources();
  }
}

@Injectable()
export class Http404Resolver implements Resolve<CmsApiResponse> {
  constructor(private cmsApiService: CmsApiService) {}
  resolve() {
    return this.cmsApiService.getHttp404Resources();
  }
}



// WEBPACK FOOTER //
// ./src/app/resolves/resolves.resolver.ts